module.exports = __webpack_public_path__ + "img/img_head.b3d8f160.png";